import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

/**
 * Token + usuario en memoria; persistencia en sessionStorage (no localStorage).
 */
export const useAuthStore = create(
  persist(
    (set) => ({
      user: null,
      token: null,
      setAuth: (user, token) => set({ user, token }),
      setUser: (user) => set({ user }),
      clearAuth: () => set({ user: null, token: null }),
    }),
    {
      name: "zx-auth",
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({ token: state.token, user: state.user }),
    }
  )
);

export function getAuthToken() {
  return useAuthStore.getState().token;
}
